import axios from "axios";
import React, { useState } from "react";
import ReactModal from "react-modal";
import Cookies from "universal-cookie";
function Comentarios(props) {
  const cookie = new Cookies();
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaPregunta",
      data: {
        encuestaId: props.idEncuesta,
        solicitudId: props.idSolicitud,
        tipoEncuestaId: props.tipo,
        usuarioId: cookie.get("id"),
        comentarios: postComentarios,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        window.alert(Response.data);
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear" + error);
      });
  };
  const [postComentarios, setPostComentario] = useState([]);
  return (
    <div>
      <button
        variant="contained"
        className="btn btn-primary "
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Añadir Nota
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-body">
                  <div class="card-header py-3">
                    <h6 class="m-0 font-weight-bold text-primary">
                      Crear Comentarios
                    </h6>
                  </div>
                  <div class="table-responsive">
                    <form className="user">
                      <div className="form-group row">
                        <div className="col-sm-12">
                          <textarea
                            rows={4}
                            type="text"
                            className="form-control form-control-user"
                            placeholder="Comentarios"
                            onChange={(e) => setPostComentario(e.target.value)}
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default Comentarios;
